import { Streami18n } from 'stream-chat-react'
import moment from 'moment'
import { currentLang, currentLangString } from '../../../i18nInit'
import { Lang } from '../../../services/api.types'
import { TranslationLanguages } from 'stream-chat'

// Get Stream language type is missing Lithuanian
type TranslationLanguagesUpdated = TranslationLanguages & 'lt'

import sqTranslation from './sq.json'
import arTranslation from './ar.json'
import bgTranslation from './bg.json'
import zhTranslation from './zh-Hans.json'
import hrTranslation from './hr.json'
import csTranslation from './cs.json'
import daTranslation from './da.json'
import etTranslation from './et.json'
import fiTranslation from './fi.json'
import elTranslation from './el.json'
import huTranslation from './hu.json'
import lvTranslation from './lv.json'
import ltTranslation from './lt.json'
import noTranslation from './no.json'
import plTranslation from './pl.json'
import roTranslation from './ro.json'
import srTranslation from './sr.json'
import skTranslation from './sk.json'
import slTranslation from './sl.json'
import svTranslation from './sv.json'
import ukTranslation from './uk.json'

import deTranslation from './replacements/de.json'
import enTranslation from './replacements/en.json'
import esTranslation from './replacements/es.json'
import frTranslation from './replacements/fr.json'
import itTranslation from './replacements/it.json'
import jaTranslation from './replacements/ja.json'
import koTranslation from './replacements/ko.json'
import nlTranslation from './replacements/nl.json'
import ptTranslation from './replacements/pt.json'
import ruTranslation from './replacements/ru.json'
import trTranslation from './replacements/tr.json'

const language = currentLang === Lang.ZH_HANS ? 'zh' : (currentLangString as TranslationLanguagesUpdated)

const i18nInstance = new Streami18n({
  language,
  DateTimeParser: moment,
})

switch (currentLang) {
  case Lang.AR:
    // @ts-ignore
    i18nInstance.registerTranslation('ar', arTranslation)
    break
  case Lang.BG:
    // @ts-ignore
    i18nInstance.registerTranslation('bg', bgTranslation)
    break
  case Lang.CS:
    // @ts-ignore
    i18nInstance.registerTranslation('cs', csTranslation)
    break
  case Lang.DA:
    // @ts-ignore
    i18nInstance.registerTranslation('da', daTranslation)
    break
  case Lang.EL:
    // @ts-ignore
    i18nInstance.registerTranslation('el', elTranslation)
    break
  case Lang.ET:
    // @ts-ignore
    i18nInstance.registerTranslation('et', etTranslation)
    break
  case Lang.FI:
    // @ts-ignore
    i18nInstance.registerTranslation('fi', fiTranslation)
    break
  case Lang.HR:
    // @ts-ignore
    i18nInstance.registerTranslation('hr', hrTranslation)
    break
  case Lang.HU:
    // @ts-ignore
    i18nInstance.registerTranslation('hu', huTranslation)
    break
  case Lang.ID:
    // @ts-ignore
    i18nInstance.registerTranslation('id', huTranslation)
    break
  case Lang.LT:
    // @ts-ignore
    i18nInstance.registerTranslation(<TranslationLanguagesUpdated>'lt', ltTranslation)
    break
  case Lang.LV:
    // @ts-ignore
    i18nInstance.registerTranslation('lv', lvTranslation)
    break
  case Lang.NO:
    // @ts-ignore
    i18nInstance.registerTranslation('no', noTranslation)
    break
  case Lang.PL:
    // @ts-ignore
    i18nInstance.registerTranslation('pl', plTranslation)
    break
  case Lang.RO:
    // @ts-ignore
    i18nInstance.registerTranslation('ro', roTranslation)
    break
  case Lang.SK:
    // @ts-ignore
    i18nInstance.registerTranslation('sk', skTranslation)
    break
  case Lang.SL:
    // @ts-ignore
    i18nInstance.registerTranslation('sl', slTranslation)
    break
  case Lang.SQ:
    // @ts-ignore
    i18nInstance.registerTranslation('sq', sqTranslation)
    break
  case Lang.SR:
    // @ts-ignore
    i18nInstance.registerTranslation('sr', srTranslation)
    break
  case Lang.SV:
    // @ts-ignore
    i18nInstance.registerTranslation('sv', svTranslation)
    break
  case Lang.UK:
    // @ts-ignore
    i18nInstance.registerTranslation('uk', ukTranslation)
    break
  case Lang.ZH_HANS:
    // @ts-ignore
    i18nInstance.registerTranslation('zh', zhTranslation)
    break
  // Official translation replacements:
  case Lang.EN:
    // @ts-ignore
    i18nInstance.registerTranslation('en', enTranslation)
    break
  case Lang.DE:
    // @ts-ignore
    i18nInstance.registerTranslation('de', deTranslation)
    break
  case Lang.ES:
    // @ts-ignore
    i18nInstance.registerTranslation('es', esTranslation)
    break
  case Lang.FR:
    // @ts-ignore
    i18nInstance.registerTranslation('fr', frTranslation)
    break
  case Lang.IT:
    // @ts-ignore
    i18nInstance.registerTranslation('it', itTranslation)
    break
  case Lang.JA:
    // @ts-ignore
    i18nInstance.registerTranslation('ja', jaTranslation)
    break
  case Lang.KO:
    // @ts-ignore
    i18nInstance.registerTranslation('ko', koTranslation)
    break
  case Lang.NL:
    // @ts-ignore
    i18nInstance.registerTranslation('nl', nlTranslation)
    break
  case Lang.PT:
    // @ts-ignore
    i18nInstance.registerTranslation('pt', ptTranslation)
    break
  case Lang.RU:
    // @ts-ignore
    i18nInstance.registerTranslation('ru', ruTranslation)
    break
  case Lang.TR:
    // @ts-ignore
    i18nInstance.registerTranslation('tr', trTranslation)
    break
  case Lang.TH:
    // @ts-ignore
    i18nInstance.registerTranslation('th', trTranslation)
    break
  case Lang.VI:
    // @ts-ignore
    i18nInstance.registerTranslation('vi', trTranslation)
    break
  default:
    console.error('Missing translation for chat.')
    break
}

export default i18nInstance
